import { dateFine } from "../../../util/Utilities";
import ActionDropdown from "../../ActionDropdown";
import CostCenterPayrrolStatusComponent from "../../CostCenterPayrrolStatusComponent";
import DateFormatter from "../../DateFormatter";
import TableCheck from "../TableCheck";

const DashboardPayrrolColumns = [
    {
        Label: () => 'Año',
        accessor: 'year'
    },
    {
        Label: () => 'Mes',
        accessor: 'period'
    },
    /* {
        Label: () => 'Tipo',
        accessor: 'type'
    }, */
    {
        Label: () => 'Estado',
        Component: CostCenterPayrrolStatusComponent
    },
    {
        Label: () => 'Centro de costo',
        Component: ({ value }) => `${value?.costCenter?.name || '--'}`
    },
    {
        Label: () => 'Fecha de Creación',
        Component: ({ value }) => <DateFormatter value={dateFine(value?.createdAt)} dateFormat="dd/MM/yyyy hh:mm:ss" />
    },
    {
        Label: () => 'Acciones',
        Component: ({ value }) => <a href={`/gestionar-nomina/${value?.id}`} className="btn btn-xs btn-primary">
            Ver detalles
        </a>
    }
];

export default DashboardPayrrolColumns;

